// utils/ossClient.js
import SlsTracker from '@aliyun-sls/web-track-browser'

export const getSLSClient =  () => {

  const opts = {
    host: 'cn-hangzhou.log.aliyuncs.com', // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
    project: 'meet-ag-client', // Project名称。
    logstore: 'web-guest', // Logstore名称。
    time: 5, // 发送日志的时间间隔，默认是10秒。
    count: 10, // 发送日志的数量大小，默认是10条。
    topic: 'topic',// 自定义日志主题。
    source: 'web',
    tags: {
      tags: 'tags',
    },
  }

  const tracker = new SlsTracker(opts);
  return tracker;
};


export const sendMessage = async (module, keyMsg,message) => {
  const client = getSLSClient();
  client.send({
    module,
    keyMsg,message
  });
}

export const getSLSClientErr =  () => {

  const opts = {
    host: 'cn-hangzhou.log.aliyuncs.com', // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
    project: 'meet-ag-client', // Project名称。
    logstore: 'web-guest-err', // Logstore名称。
    time: 5, // 发送日志的时间间隔，默认是10秒。
    count: 10, // 发送日志的数量大小，默认是10条。
    topic: 'topic',// 自定义日志主题。
    source: 'web',
    tags: {
      tags: 'tags',
    },
  }

  const tracker = new SlsTracker(opts);
  return tracker;
};

export const sendMessageErr = async (uid,email,module, keyMsg,message) => {
  const client = getSLSClientErr();
  client.send({
    uid,email,
    module,
    keyMsg,message
  });
}